import React from 'react';

const FetchError = ({ message }) => (
    <p className="red-text" hidden={!message}> 
        <i className="fas fa-exclamation-triangle"></i>
        {message} 
    </p>
);

export default FetchError;